import { AvailableServicesFormData } from '../../../types/forms'
import { OnboardingFormState } from '../../../types/state'
import { getSelectedCompany } from './getSelectedCompany'
import { setNewCompanies } from './setNewCompanies'

export const availableServicesToState = ({
  companyIndex,
  currentState,
  formData
}: {
  companyIndex: number
  currentState: OnboardingFormState
  formData: AvailableServicesFormData
}) => {
  const oldCompanies = currentState.formValue.companiesFormValues
  const oldCompany = getSelectedCompany({ companyIndex, currentState })

  // change ref in list
  const newCompaniesFormValues = setNewCompanies({
    oldCompanies,
    companyIndex,
    newCompany: { ...oldCompany, availableServices: { ...formData } }
  })

  return {
    formValue: {
      ...currentState.formValue,
      companiesFormValues: newCompaniesFormValues
    }
  }
}
